export default "__VITE_ASSET__D4rp$gGC__"